import React from 'react';
import { motion } from 'framer-motion';
import { fadeUp } from '../../lib/animations';

const Section = ({ children, className = "", delay = 0 }) => {
    return (
        <motion.div
            initial="hidden"
            whileInView="visible"
            viewport={{ once: true, margin: "-100px" }}
            variants={fadeUp}
            custom={delay}
            className={className}
        >
            {children}
        </motion.div>
    );
};

export default Section;
